import gql from 'graphql-tag'
import { useMutation } from '@apollo/client'

export const CREATE_IMPERSONATION_RIGHT_MUTATION = gql`
    mutation createImpersonationRight(
        $userId: Int!
        $tenantGuid: String!
        $expirationDateTime: DateTime
    ) {
        createImpersonationRight(
            userId: $userId
            tenantGuid: $tenantGuid
            expirationDateTime: $expirationDateTime
        ) {
            impersonationRight {
                id
                key
                expirationDateTime
            }
        }
    }
`

export default function useCreateImpersonationRightMutation() {
    return useMutation(CREATE_IMPERSONATION_RIGHT_MUTATION)
}
